module.exports = __webpack_public_path__ + "static/media/Fachinformation_Revestive 1.25mg & 5mg Stand 05_20.195376d5.pdf";